import { css, type SerializedStyles } from '@emotion/react';

import { styleguideSpacing } from '@kaiizen/kai-shiki/core';

export type SuperAdminToolsModalStyles = {
  tabBar: SerializedStyles;
  hiddenTab: SerializedStyles;
};

export const DEFAULT_SUPER_ADMIN_TOOLS_MODAL_STYLES: SuperAdminToolsModalStyles = {
  tabBar: css`
    label: SUPER_ADMIN_TOOLS_TAB_BAR;
    padding: ${styleguideSpacing.s4}px ${styleguideSpacing.s5}px 0;
  `,
  hiddenTab: css`
    label: SUPER_ADMIN_TOOLS_HIDDEN_TAB;
    display: none;
  `,
};
